import React from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

const baseURL = process.env.REACT_APP_HR_API_URL || 'http://localhost:5001';

function apiUrl(token) {
  return `${String(baseURL).replace(/\/+$/, '')}/api/auth/deep-link/${encodeURIComponent(String(token))}`;
}

async function redeemDeepLink(rawToken) {
  const res = await fetch(apiUrl(rawToken), { method: 'POST', headers: { Accept: 'application/json' } });
  let data = null;
  try { data = await res.json(); } catch (_) { data = null; }
  if (!res.ok) {
    const msg = data && (data.message || data.msg) ? (data.message || data.msg) : 'This link is invalid or has expired.';
    const err = new Error(msg);
    err.status = res.status;
    if (data && data.alreadyDecided) err.alreadyDecided = true;
    if (data && data.status) err.decisionStatus = data.status;
    throw err;
  }
  return data;
}

export default function DeepLinkApprove() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = React.useState('working'); // working | error
  const [errorTitle, setErrorTitle] = React.useState('Link no longer valid');
  const [errorMsg, setErrorMsg] = React.useState('');

  // useRef guard prevents a second API call if React StrictMode double-fires the effect.
  const attempted = React.useRef(false);

  React.useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    redeemDeepLink(token)
      .then((data) => {
        if (!data?.token) throw new Error('Sign-in failed: no token received.');
        localStorage.setItem('token', data.token);
        const entityType = data.entityType === 'overtime' ? 'overtime' : 'holiday';
        const entityId = data.entityId || '';
        navigate(`/manager?dl_type=${encodeURIComponent(entityType)}&dl_id=${encodeURIComponent(entityId)}`, { replace: true });
      })
      .catch((err) => {
        const st = err?.status;
        if (st === 410 && err?.alreadyDecided) {
          const s = err.decisionStatus === 'approved' ? 'approved'
            : err.decisionStatus === 'rejected' ? 'rejected'
            : String(err.decisionStatus || '');
          setErrorTitle(s ? `Request already ${s}` : 'Request already decided');
          setErrorMsg(s
            ? `This request has already been ${s}. No further action is needed.`
            : (err.message || 'This request has already been decided.'));
        } else {
          setErrorTitle('Link no longer valid');
          setErrorMsg(err?.message || 'This link is invalid, expired, or has already been used.');
        }
        setStatus('error');
      });
  }, [token, navigate]);

  if (status === 'working') {
    return (
      <div className="container py-5" style={{ maxWidth: 680 }}>
        <h3 className="mb-2">Signing you in…</h3>
        <p className="text-muted mb-0">Please wait. You will be redirected automatically.</p>
      </div>
    );
  }

  return (
    <div className="container py-5" style={{ maxWidth: 680 }}>
      <div className="card shadow-sm">
        <div className="card-body p-4">
          <h4 className="mb-2 text-danger">{errorTitle}</h4>
          <p className="text-muted mb-4">{errorMsg}</p>
          <Link className="btn btn-primary" to="/login">Go to Login</Link>
        </div>
      </div>
    </div>
  );
}
